import { TrackingEnv } from '@app/core/services/tracking/tracking.env';
import { AppType, IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  production: false,
  ciamAPIUrl:
    'https://prd-weu1-rc-df-ciam-api-webservice-dev.cloud-effem.com/lifecycle',
  apimAPIUrl: 'https://dev-eus2-rcapi-apim.azure-api.net/ciam',
  contactUsApiUrl:
    'https://int-eus2-rcapi-apim.azure-api.net/internal/myaccount/contactus',
  myAccountBffUrl: 'https://prd-weu1-rc-df-myaccount-bff-dev.cloud-effem.com',
  OcpApimSubscriptionKey: '18e2b7217026439d9da33b136021ed55',
  globalRedirectUri: 'https://royalcanin.com',
  environmentName: 'dev',
  trackingEnv: TrackingEnv.local,
  okta: {
    domain: 'accountdev.royalcanin.com',
    clientId: '0oau9oiqwseoPDv3X0h7',
    socialIdp: {
      facebook: '0oat2htelxpazCKA70h7',
      google: '0oas0dmwhfcnkpIW80h7',
      paypal: '0oa1dk36l8aOn5Eyt0h8',
      apple: '0oa16v3rc7ooEUsLt0h8',
      kakao: '0oa1kliaeck76rdKv0h8',
    },
  },
  appType: AppType.RC,
  isWhiteLabel: false,
  gdpRedirectURI: 'https://signin-dev.gdp.royalcanin.com',
};
